import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { FormDesktop as Form } from './components/form/desktop/desktop';
import { Case } from './components/case';
import { FormLayoutDesktop as FormLayout } from './layouts/form-layout/desktop';
import { SmsLayoutDesktop as SmsLayout } from './layouts/sms-layout/desktop/desktop';
import { SuccessSendLayoutDesktop as SuccessSendLayout } from './layouts/success-send-layout/desktop/desktop';
import { ErrorSendLayoutDesktop as ErrorSendLayout } from './layouts/error-send-layout/desktop/desktop';
import { AlfaleasingLeasingFormV5 as Component } from './leasing-form';
import { StepByStepLayoutDesktop as StepByStepLayout } from './layouts/step-by-step-layout/desktop';
import { SuccessWithRedirectLayoutDesktop as SuccessWithRedirectLayout } from './layouts/success-with-redirect-layout/desktop';
import type { TAlfaleasingLeasingFormV5Desktop, IDepsDesktop } from './models';

export const AlfaleasingLeasingFormV5Desktop = createWidget<
    IDepsDesktop,
    TAlfaleasingLeasingFormV5Desktop
>({
    Form,
    FormLayout,
    SuccessSendLayout,
    SmsLayout,
    StepByStepLayout,
    SuccessWithRedirectLayout,
    ErrorSendLayout,
    Case,
})(Component);
